import loadScript from '../util/loader';

const defaultOptions = {
  autoplay: true,
  loop: true,
  controls: true,
  muted: false,
  playsinline: true,
};

const selectors = {
  player: 'iframe, [data-replace]',
  videoId: 'data-video-id',
};

export default function embedVimeo(uniqueKey, options) {
  const playerOptions = {
    ...defaultOptions,
    ...options,
  };
  const playerWrapper = document.querySelector(`[data-player="${uniqueKey}"]`);
  const playerElement = playerWrapper.querySelector(selectors.player);
  const vimeoKey = playerWrapper.querySelector(`[${selectors.videoId}]`).getAttribute(selectors.videoId);
  const loadedPromise = loadScript({url: 'https://player.vimeo.com/api/player.js'});
  const vimeoSelector = `select-${uniqueKey}`;
  playerElement.setAttribute('id', vimeoSelector);
  const returnPlayer = loadedPromise
    .then(() => {
      const player = new window.Vimeo.Player(vimeoSelector, {
        ...playerOptions,
        id: vimeoKey,
      });

      // We need these play/pause events because the Vimeo video does not emit the regular play/pause events on Mobile
      player.on('play', () => {
        playerWrapper.dispatchEvent(new CustomEvent('play'));
      });
      player.on('pause', () => {
        playerWrapper.dispatchEvent(new CustomEvent('pause'));
      });

      playerWrapper.addEventListener('pause', () => {
        try {
          if (player.pause) {
            player.pause();
          }
        } catch (e) {
          console.warn(e);
        }
      });
      playerWrapper.addEventListener('play', () => {
        if (player.play) {
          // Check if it is paused to avoid playing an already playing video which sometimes results in an error
          player.getPaused().then((paused) => {
            if (paused) {
              player.play();
            }
          });
        }
      });
      playerWrapper.addEventListener('destroy', () => {
        try {
          if (player.destroy) {
            player.destroy();
          }
        } catch (e) {
          console.log(e);
        }
      });
      return player;
    })
    .catch((err) => {
      console.error(err);
    });
  return returnPlayer;
}
